import { render, staticRenderFns } from "./ViewerSpinnerLoader.vue?vue&type=template&id=78df7540&scoped=true"
import script from "./ViewerSpinnerLoader.vue?vue&type=script&lang=js"
export * from "./ViewerSpinnerLoader.vue?vue&type=script&lang=js"
import style0 from "./ViewerSpinnerLoader.vue?vue&type=style&index=0&id=78df7540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78df7540",
  null
  
)

export default component.exports